// @ts-nocheck
// Legacy, and only in the type-check program because an FSD slice imports it through
// one of the two sanctioned exceptions. Its own types were never checked and fixing
// them means guessing at API semantics — out of scope for the FSD migration. Drop this
// line when the file is migrated.
import apiClient from '@/utils/request'
import { Device, Platform } from '@/api/types'

export interface IConfig {
  stop_words: string[]
  ab_cname_domain: string
  asgo_domain: string
  usage_fee_amount: number
  usage_fee_percent: number
  eur_to_usd: string
  faq_pages: string[]
  adsecure_devices: Record<Device, string[]> | Record<string, never>
  adsecure_alerts: Record<string, string> | Record<string, never>
  adsexplorer_alerts: Record<string, string> | Record<string, never>
  custom_alerts: Record<string, string> | Record<string, never>
  adsecure_defaults: string[]
  adsexplorer_defaults: string[]
  custom_defaults: string[]
  adsexplorer_devices: Record<Device, string> | Record<string, never>
  adsexplorer_platforms: Record<Platform, string> | Record<string, never>
  adsexplorer_browsers: Record<Browser, string> | Record<string, never>
}

export const fetchItem = async (): Promise<IConfig> => {
  const response = await apiClient.get<IConfig>('/config')
  return response.data
}
